import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { COMPANIES, LIBRARIES, PLUGINS, PRODUCT_LINES, SERVICES } from 'src/app/data/product/product.data';
import { URLS } from '../../../data/navigation/navigation.data';
import { CompanyLine, ProductLine } from '../../../model/product/product.model';
import { LoadingService } from '../../../service/loading/loading.service';
import { DropdownMenuComponent } from '../../dropdown-menu/dropdown-menu.component';
import { CompanyDropdownComponent } from '../../company-dropdown/company-dropdown.component';

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.scss']
})
export class BottomNavComponent {
  loading = false;
  pageTwoOpened = false;

  URLS = URLS;

  PRODUCT_LINES: ProductLine[] = PRODUCT_LINES;
  SERVICES: ProductLine[] = SERVICES;
  LIBRARIES: ProductLine[] = LIBRARIES;
  PLUGINS: ProductLine[] = PLUGINS;
  COMPANIES: CompanyLine[] = COMPANIES;

  @ViewChild('dropdownMenuProducts') dropdownMenuProducts: DropdownMenuComponent;
  @ViewChild('dropdownMenuLibraries') dropdownMenuLibraries: DropdownMenuComponent;
  @ViewChild('dropdownMenuPlugins') dropdownMenuPlugins: DropdownMenuComponent;
  @ViewChild('dropdownMenuServices') dropdownMenuServices: DropdownMenuComponent;
  @ViewChild('dropdownMenuCompanies') dropdownMenuCompanies: CompanyDropdownComponent;

  constructor(
    private router: Router,
    private loadingService: LoadingService
  ) {
    this.loadingService.sharedLoading.subscribe(loading => this.loading = loading);
  }

  closeDropdowns(dropdownMenus: DropdownMenuComponent[]) {
    dropdownMenus.forEach(dropdownMenu => dropdownMenu.closeDropdown());
  }

  closeOtherDropDowns(dropDownMenu: any) {
    const dropdownMenus = [];
    dropdownMenus.push(this.dropdownMenuProducts, this.dropdownMenuLibraries, this.dropdownMenuPlugins, this.dropdownMenuServices, this.dropdownMenuCompanies);

    dropdownMenus.forEach(menu => {
      if (menu !== dropDownMenu) {
        menu.closeDropdown();
      }
    });
  }

  closeAllDropDowns() {
    this.dropdownMenuProducts.closeDropdown();
    this.dropdownMenuLibraries.closeDropdown();
    this.dropdownMenuPlugins.closeDropdown();
    this.dropdownMenuServices.closeDropdown();
    this.dropdownMenuCompanies.closeDropdown();
  }
}
